import Api from '@/shared/services/Api'


export default 
{

	get() {
		return Api().get('package-get')
	},

	getForHome() {
		return Api().get('package-get-for-home')
	},

	getPricesSend(data) {
		return Api().post('package-get-prices-send', data)
	},

	getPricesSendFinal(data) {
		return Api().post('package-get-prices-send-final', data)
	},

}